module.exports = __webpack_public_path__ + "static/assets/d8a768fd8d4769c59ad6b9ba5806a027.svg";